// APP
export const APP_SET_THEME = 'APP_SET_THEME';
export const APP_SET_APPLICATION = 'APP_SET_APPLICATION';
export const APP_SET_UNIT_SYSTEM = 'APP_SET_UNIT_SYSTEM';
export const APP_SET_LANGUAGE = 'APP_SET_LANGUAGE';

// AUTH
export const AUTH_LOG_USER_IN = 'AUTH_LOG_USER_IN';
export const AUTH_SET_USER_DETAILS = 'AUTH_SET_USER_DETAILS';
export const AUTH_SET_USER = 'AUTH_SET_USER';
export const AUTH_LOG_USER_OUT = 'AUTH_LOG_USER_OUT';

// SESSION
export const SESSION_SET_CURRENT_CUSTOMER = 'SESSION_SET_CURRENT_CUSTOMER';
export const SESSION_SET_LISTING_TYPE = 'SESSION_SET_LISTING_TYPE';
export const SESSION_SET_LISTASYNCPROCESS = 'SESSION_SET_LISTASYNCPROCESS';
export const SESSION_ADD_LISTASYNCPROCESS = 'SESSION_ADD_LISTASYNCPROCESS';
export const SESSION_REMOVE_LISTASYNCPROCESS = 'SESSION_REMOVE_LISTASYNCPROCESS';
export const SESSION_UPDATE_LISTASYNCPROCESS = 'SESSION_UPDATE_LISTASYNCPROCESS';
export const SESSION_CLEAN_LISTASYNCPROCESS = 'SESSION_CLEAN_LISTASYNCPROCESS';
